var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NoticesContainer"},_vm._l((_vm.notices),function(notice){return _c('notice',{key:notice.id,attrs:{"message":notice.message,"icon":notice.icon,"has-spinner":notice.hasSpinner,"hide-on-click":notice.hideOnClick,"on-click":notice.onClick},on:{"hide":function($event){return _vm.hide(notice)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }